import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { JobWizardPage, type JobWizardPrefill } from '@/features/jobs/job-wizard';
import { isJobType } from '@/features/jobs/types';
import { ConsoleShell } from '@/features/shell/console-shell';

/**
 * Nouveau job — `new/job` en legacy. Le préremplissage vit dans l'URL : `?type=lowcode&graph=…`
 * depuis le bouton « Créer un job » de l'éditeur, `?from=<job>` depuis « Dupliquer ».
 */
export const Route = createFileRoute('/$tenant/projects/$projectId/jobs/new')({
  validateSearch: (search: Record<string, unknown>): JobWizardPrefill => ({
    ...(isJobType(search['type']) ? { type: search['type'] } : {}),
    ...(typeof search['graph'] === 'string' && search['graph'] ? { graph: search['graph'] } : {}),
    ...(typeof search['from'] === 'string' && search['from'] ? { from: search['from'] } : {}),
  }),
  component: NewJobRoute,
});

function NewJobRoute() {
  const { tenant, projectId } = Route.useParams();
  const prefill = Route.useSearch();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      projectId={projectId}
      activeItem="jobs"
      crumbs={[{ label: t('nav.items.jobs') }, { label: t('jobs.wizard.title') }]}
    >
      {/* `key` : un autre préremplissage (autre graphe, autre job copié) repart d'un assistant neuf. */}
      <JobWizardPage
        key={`${prefill.type ?? ''}|${prefill.graph ?? ''}|${prefill.from ?? ''}`}
        tenantId={tenant}
        projectId={projectId}
        prefill={prefill}
      />
    </ConsoleShell>
  );
}
